module.exports = __webpack_public_path__ + "static/media/back-card.9c6596e3.svg";